import { cssThemedValue } from '@creditornot/cb-ingredients';
import { MenuAccordionItem } from '@creditornot/cb-menu';
import React, { ReactNode, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { Typography } from 'common/typography';

const TopTipsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid ${cssThemedValue('borderPrimary')};
`;

const TopTipsHeadingContainer = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-block-end: 1px solid ${cssThemedValue('borderPrimary')};
`;

const TopTipsListContainer = styled.div`
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

const ExpandableTip = ({ question, answer }: { question: string; answer: ReactNode }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  return (
    <MenuAccordionItem
      key={question}
      accordionContent={
        <div>
          <Typography.Body3 as={'p'}>{answer}</Typography.Body3>
        </div>
      }
      open={isOpen}
      onClick={() => setIsOpen(!isOpen)}
    >
      <strong>{question}</strong>
    </MenuAccordionItem>
  );
};

export const TopTips = () => {
  const { formatMessage } = useIntl();
  const tips = [
    'best-of-wolt.top-tips.improve-rating',
    'best-of-wolt.top-tips.order-rejections',
    'best-of-wolt.top-tips.online-time',
    'best-of-wolt.top-tips.incorrect-items',
  ];

  return (
    <TopTipsContainer>
      <TopTipsHeadingContainer>
        <Typography.Heading6>
          <FormattedMessage id="best-of-wolt.top-tips.title" />
        </Typography.Heading6>
      </TopTipsHeadingContainer>
      <TopTipsListContainer>
        {tips.map(tip => (
          <ExpandableTip
            key={tip}
            question={formatMessage({
              id: `${tip}.question`,
            })}
            answer={formatMessage(
              {
                id: `${tip}.answer`,
              },
              {
                paragraph: (text: string) => <p>{text}</p>,
              },
            )}
          />
        ))}
      </TopTipsListContainer>
    </TopTipsContainer>
  );
};
